import { axios } from '../utils'

export default {
  namespaced: true,

  state: {
    loading: false,
    clients: [],
    payAsYouGo: false,
    additionalFilter: false,
    headers: [
      {
        text: 'id',
        value: 'id'
      },
      {
        text: 'Client',
        align: 'start',
        value: 'client_name'
      },
      {
        text: 'Business',
        align: 'start',
        value: 'business_name'
      },
      {
        text: 'Email',
        align: 'start',
        value: 'email'
      },
      {
        text: 'Messages Sent',
        align: 'start',
        value: 'text_messages_count'
      },
      { text: 'Report', align: 'center', value: 'report', sortable: false },
      { text: 'Edit', align: 'center', value: 'edit', sortable: false },
      { text: 'Delete', align: 'center', value: 'delete', sortable: false }
    ]
  },
  getters: {
    getPayAsYouGo(state) {
      return state.payAsYouGo
    },
    getAdditionalFilter(state) {
      return state.additionalFilter
    }
  },
  actions: {
    setClients({ commit }, payload) {
      commit('SET_CLIENT', payload)
    },
    setAdditionalFilter({ commit }, payload) {
      commit('SET_ADDITIONAL_FILTER', payload); // Commit the mutation
    },
    getClients({ commit, state }, { options, search, employee, additionalFilter }) {
      let _employee = ''
      if (employee) {
        _employee = encodeURIComponent(employee)
      }
      commit('SET_LOADING', true)
      axios
        .get(
          `api/admin/clients?page=${options.page}&itemsPerPage=${
            options.itemsPerPage
          }&search=${search}&employee=${_employee}&pay_as_you_go=${
            state.payAsYouGo ? 1 : 0
          }&additional_filter=${additionalFilter}`
        )
        .then(res => {
          commit('SET_CLIENT', res.data)
          commit('SET_LOADING', false)
        })
    },
    setPayAsYouGo({ commit }, payload) {
      commit('SET_PAY_AS_YOU_GO', payload)
    }
  },
  mutations: {
    SET_CLIENT(state, payload) {
      state.clients = payload
    },
    SET_LOADING(state, payload) {
      state.loading = payload
    },
    SET_PAY_AS_YOU_GO(state, payload) {
      state.payAsYouGo = payload
    },
    SET_ADDITIONAL_FILTER(state, payload) {
      state.additionalFilter = payload; // Set the new state variable
    },
  }
}
